import { ProductInfoSource } from "~/components/StoreInfo/types";
import { Stars } from "~/components/Stars/Stars";
import { useTranslation } from "react-i18next";
import { AppLink, useStoreImages } from "@commons-monorepo/index";
import styles from "~/components/StoreInfo/StoreInfo.module.css";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { useOutletContext } from "react-router-dom";
import { StatisticsResume } from "~/common/props/orchestrator";
import { useMemo } from "react";

type StoreInfoProps = {
  source: ProductInfoSource;
  textButton?: string;
  to?: string;
  onViewStoreReviews?: () => void;
  partner?: any;
};

export const StoreInfo = ({
  source,
  onViewStoreReviews,
  partner
}: StoreInfoProps) => {
  const { t } = useTranslation();
  const { theme } = useGlobalStyles();
  const { storeMetadata } = useOutletContext<any>();
  const { partnerProfilePicture } = useStoreImages(storeMetadata);
  const statisticsResume: StatisticsResume = storeMetadata.statisticsResume;

  const logistic = useMemo(() => {
    return partner?.logisticConfiguration?.nationalLogisticEnabled ?
    t("StoreInformation.national") :
    partner?.logisticConfiguration?.localLogisticEnabled ||
    partner?.logisticConfiguration?.customDeliveryEnabled ?
    t("StoreInformation.local") :
    undefined;
  }, [partner]);

  const handleViewReviews = () => {
    onViewStoreReviews && onViewStoreReviews();
  };

  function formatNumber(number: string) {
    return number.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  return (
    <div
      className={`${styles.storeInfoContainerStyled}`}
      aria-label='store-info-container'>

      <div className={`${styles.storeInfoContentStyled}`}>
        {source === ProductInfoSource.StoreInfoPage &&
        <div className={`${styles.storeInfoCopyDetailsExpanded}`}>
            <img src={partnerProfilePicture} alt={"logo"} />
            <div className={`${styles.info}`} aria-label='store-info-scoreName'>
              <span className={`${styles.description}`}>
                {partner?.enterpriseName}
              </span>
              {statisticsResume?.score && statisticsResume?.score > 0 ?
            <Stars
              number={statisticsResume.score}
              color={`${theme.themeColors.button}`} /> :


            <Stars number={5} />}

            </div>
          </div>}

        <div className={`${styles.storeInfoGrid}`}>
          {source === ProductInfoSource.ProductPage &&
          <div
            className={`${styles.storeInfoItemStyled}`}
            aria-label='store-info-name'>

              <div className={`${styles.boxIcon}`}>
                <span className={`icon-store`}></span>
              </div>
              <div className={`${styles.storeInfoCopyDetailsStyled}`}>
                <span className={`${styles.title}`}>
                  {t("StoreInformation.name")}
                </span>
                <span className={`${styles.description}`}>
                  {partner?.enterpriseName}
                </span>
              </div>
            </div>}

          <div
            className={`${styles.storeInfoItemStyled}`}
            aria-label='store-info-location'>

            <div className={`${styles.boxIcon}`}>
              <span className='icon-map-pin-line'></span>
            </div>
            <div className={`${styles.storeInfoCopyDetailsStyled}`}>
              <span className={`${styles.title}`}>
                {t("StoreInformation.location")}
              </span>
              <span className={`${styles.description}`}>
                {partner?.storeCity ? `${partner?.storeCity}, ` : ""}
                {partner?.country ? partner?.country : ""}
              </span>
            </div>
          </div>

          {logistic &&
          <div
            className={`${styles.storeInfoItemStyled}`}
            aria-label='store-info-coverage'>

              <div className={`${styles.boxIcon}`}>
                <span className={`icon-truck ${styles.truckSize}`}></span>
              </div>
              <div className={`${styles.storeInfoCopyDetailsStyled}`}>
                <span className={`${styles.title}`}>
                  {t("StoreInformation.coverage")}
                </span>
                <span className={`${styles.description}`}>
                  <span className={`${styles.description}`}>{logistic}</span>
                </span>
              </div>
            </div>}

        </div>
        {source === ProductInfoSource.ProductPage &&
        !!statisticsResume?.score &&
        statisticsResume?.score > 0 &&
        <div className={`${styles.scoreBox}`} aria-label='store-info-score'>
              <span className={`${styles.title}`}>
                {t("StoreInformation.score")}
              </span>
              <div className={`${styles.scoreBoxStars}`}>
                <Stars number={statisticsResume.score} color='#E58D09' />
              </div>
            </div>}

      </div>
    </div>);

};